// Shaded backdrop
const mobile_backdrop = document.getElementById("mobile-backdrop");

// Move the slider to specified position to show clicked colour
window.changeSlide = (e) => {
  // get product id
  const productId = e.currentTarget.dataset.productId;
  if (window[`swiper-product_${productId}`]) {
    window[`swiper-product_${productId}`].slideTo(
      e.currentTarget.dataset.index
    );
  }
};

// Return a variant id given a colour and size option
const getVariant = (card) => {
  let selectedOptions = card.querySelectorAll(".prd-Card_Option.active");
  const variants = JSON.parse(
    card.querySelector("#product_variants").innerHTML
  );
  return variants.find((variant) => {
    let count = 0;

    selectedOptions.forEach((selectedOption) => {
      // variant.options eg ["XL", "Red"]
      const found = variant.options.includes(
        selectedOption.dataset.productOptionValue
      );
      if (found) count++;
    });

    if (count === variant.options.length) return variant;
  });
};

function findAncestor(el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

/***** LISTENING FOR CLICKS ON DOCUMENT AS WE NEED THESE TO WORK ON ELEMENTS NOT PRESENT ON PAGE LOAD *****/
document.addEventListener("click", function (e) {

  if (e.target.matches(".js-AddToCart_Submit")) {
    // get the top level parent of the card
    let currentPopup = findAncestor(e.target, "prd-card__buy--options");
    currentPopup.classList.remove("active");
    // Hide the backdrop
    mobile_backdrop.classList.remove("show");
  }
  // close the quick add popup
  if (e.target.matches(".prd-Card_Popup-Close")) {
    // get the top level parent of the card
    const currentPopup = findAncestor(e.target, "prd-card__buy--options");
    currentPopup.classList.remove("active");

    mobile_backdrop.classList.remove("show");

    // TODO: reset form?
  }

  if (e.target.matches('#mobile-backdrop')) {
    // Hide the backdrop
    e.target.classList.remove('show');

    // Close any open popups
    document
      .querySelectorAll('.prd-card__buy--options')
      .forEach((popup) => popup.classList.remove('active'));
  }

  // Click handler to open product popup
  if (e.target.matches(".js-click-svg")) {
    mobile_backdrop.classList.add("show");

    //car-Carousel_Item
    let parent =
      e.target.closest(".clc-List_Item") ||
      e.target.closest(".car-Carousel_Item");
    let productId = parent.dataset.productId;

    document
      .querySelector(`#prd-card__buy--options-${productId}`)
      .classList.add("active");
  }

  // Clicking on a colour swatch in product card
  if (e.target.matches(".prd-color-tile-option")) {
    // Set/remove active classes
    const children = e.target.closest(".colourOptions_list").children;
    for (const child of children) {
      child.classList.remove("active");
    }
    // Add active class to current
    e.target.classList.add("active");

    const color = e.target.dataset.productOptionValue;

    // Set the colour label text
    const prodCardColLabel = e.target
      .closest(".prd-Card")
      .querySelector(".card-prodColour-label__val");
    prodCardColLabel.innerHTML = color;

    // Also select the corresponding option in the popup
    // Index of the current swatch
    const swatchIndex = e.target.dataset.index;
    // Select the corresponding popup
    // Get the product index
    const productId = findAncestor(e.target, "clc-List_Item").dataset.productId;
    // Get the corresponding popup
    const prdPopup = document.querySelector(
      `#prd-card__buy--options-${productId}`
    );
    // Trigger click on corresponding swathc in popup
    prdPopup
      .querySelectorAll(".colorProductOptions_tile-option")
      [swatchIndex].click();
  }

  // click on colour swatch inside popup
  if (e.target.matches(".prd-Card_Option")) {
    // get the top level parent of the card
    let currentPopup = findAncestor(e.target, "prd-card__buy--options");
    // const form = currentPopup.querySelector("form");

    /////////////
    // Update active classes
    const children = e.target.parentElement.children;
    for (const child of children) {
      child.classList.remove("active");
    }

    // Add active class to current
    e.target.classList.add("active");

    /// Do the following if it's a colour option
    if ("colour" in e.target.dataset) {

      let color = e.target.dataset.productOptionValue;

      // Update the colour label text
      currentPopup.querySelector(".card-prodColour-label__val").innerHTML =
        color;

      // Trigger a click on the corresponding swatch on the main product card ???
      const productId = currentPopup.dataset.productId;
      // Get the product card
      const productCard = document.querySelector(`#clc-List_Item-${productId}`);

      const currentIndex = e.target.dataset.index;
      if (productCard) {

        productCard
          .querySelectorAll(".prd-color-tile-option")
          [currentIndex].click();
      }

      /****************** POPUP IMAGES ********************/
      // set the image to the currently selected colour variant image
      // add conditional to check if the src of the variant image and the current is the same
      // get the current image src
      let currProdCardPopupImgSrc = currentPopup
        .querySelector(".prd-card__Popup-content__img img")
        .getAttribute("src");

      // conditional to check the src and the current is the same
      if (currProdCardPopupImgSrc != e.target.getAttribute("data-img-src")) {
        // update the image if it is different
        // update padding if anything but the first colour is clicked (images have different whitespace compared to the first)
        if (
          e.target.getAttribute("data-img-src") !=
          e.target.getAttribute("data-first-img")
        ) {
          // get current screen width
          if (window.innerWidth < 450) {
            currentPopup.querySelector(
              ".prd-card__Popup-content__img"
            ).style.padding = "1.5rem 1.5rem 1.5rem 0rem";
          } else {
            currentPopup.querySelector(
              ".prd-card__Popup-content__img"
            ).style.padding = "1.5rem";
          }
        } else {
          currentPopup.querySelector(
            ".prd-card__Popup-content__img"
          ).style.padding = "0";
        }
        currentPopup
          .querySelector(".prd-card__Popup-content__img img")
          .setAttribute("src", e.target.getAttribute("data-img-src"));
      }

      /****************** UPDATE BUTTON TEXT ********************/

      //  reset the add to cart button text to the default
      // prdPopup.querySelector(
      //   ".prd-Card_Form .js-AddToCart_Submit"
      // ).innerHTML = prdPopup
      //   .querySelector(".prd-Card_Form .js-AddToCart_Submit")
      //   .getAttribute("data-select-size-text");
    }

    // get the variant id
    // let id = el.getAttribute("data-variant-id");
    const variant = getVariant(currentPopup);

    if (variant != undefined) {
      // If available, enable the submit button
      const { id, available, price } = variant;
      const submitButton = currentPopup.querySelector(
        ".prd-Card_Form .js-AddToCart_Submit"
      );
      const selectedButtonText = submitButton.dataset.addToCartText;
      if (available) {
        [(currentPopup.querySelector("[data-add-to-cart]").disabled = false)];

        submitButton.innerHTML = selectedButtonText;
      } else {
        submitButton.innerHTML = "PLEASE CHOOSE";
        [(currentPopup.querySelector("[data-add-to-cart]").disabled = true)];
      }
      // get the variant image
      // let variantImage = el.getAttribute('data-variant-image');

      // update the form add to cart id's
      currentPopup.querySelector(".prd-Card_Form").setAttribute("id", id);
      currentPopup
        .querySelector(".prd-Card_Form [name=id]")
        .setAttribute("value", id);

      // update the price
      let UKSterling = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
      });
      currentPopup.querySelector(
        ".prd-card__Popup-content__price"
      ).innerHTML = `${UKSterling.format(price / 100)}`;

      // Switch the image in the popup
    }
  }
});
/***** END OF DOCUMENT CLICK EVENT LISTENERS *****/
